(() => {
  const roots = document.querySelectorAll('[data-noorize-home]');
  if (!roots.length) return;

  roots.forEach((root) => {
    const searchToggle = root.querySelector('[data-search-toggle]');
    const closeSearch = () => {
      root.classList.remove('search-open');
      searchToggle?.setAttribute('aria-expanded', 'false');
    };
    const openMenu = () => {
      closeSearch();
      root.classList.add('menu-open');
    };
    const closeMenu = () => root.classList.remove('menu-open');

  root.querySelectorAll('[data-menu-toggle]').forEach((button) => {
    button.addEventListener('click', openMenu);
  });

  root.querySelectorAll('[data-menu-close]').forEach((button) => {
    button.addEventListener('click', closeMenu);
  });

  searchToggle?.addEventListener('click', () => {
    const isOpen = root.classList.toggle('search-open');
    searchToggle.setAttribute('aria-expanded', String(isOpen));
    if (isOpen) closeMenu();
  });

  root.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeMenu();
      closeSearch();
    }
  });

  const header = root.querySelector('.site-header');
  const topbar = root.querySelector('.topbar');
  const updateStickyHeader = () => {
    if (!header) return;
    root.style.setProperty('--noorize-sticky-header-height', `${header.offsetHeight}px`);
    const threshold = topbar ? topbar.offsetHeight : 0;
    root.classList.toggle('header-is-fixed', window.scrollY > threshold);
  };

  window.addEventListener('scroll', updateStickyHeader, { passive: true });
  window.addEventListener('resize', updateStickyHeader);
  updateStickyHeader();

  root.querySelectorAll('[data-hero-carousel]').forEach((carousel) => {
    const slides = [...carousel.querySelectorAll('.hero-slide')];
    const dots = [...carousel.querySelectorAll('.hero-dots button')];
    let index = 0;

    const showSlide = (nextIndex) => {
      index = nextIndex;
      slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === index));
      dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
    };

    dots.forEach((dot, dotIndex) => {
      dot.addEventListener('click', () => showSlide(dotIndex));
    });

    window.setInterval(() => {
      showSlide((index + 1) % slides.length);
    }, 5200);
  });

  const updateProgress = (wrap) => {
    const track = wrap.querySelector('.circle-track');
    const progress = wrap.querySelector('.circle-rule span');
    if (!track || !progress) return;

    const max = track.scrollWidth - track.clientWidth;
    const width = max <= 0 ? 100 : Math.max(18, ((track.scrollLeft + track.clientWidth) / track.scrollWidth) * 100);
    progress.style.width = `${Math.min(width, 100)}%`;
  };

    root.querySelectorAll('[data-circle-carousel]').forEach((wrap) => {
    const track = wrap.querySelector('.circle-track');
    const prev = wrap.querySelector('.circle-prev');
    const next = wrap.querySelector('.circle-next');
    if (!track) return;

    const scrollByPage = (direction) => {
      const amount = Math.max(track.clientWidth * 0.78, 220);
      track.scrollBy({ left: direction * amount, behavior: 'smooth' });
    };

    prev?.addEventListener('click', () => scrollByPage(-1));
    next?.addEventListener('click', () => scrollByPage(1));
    track.addEventListener('scroll', () => updateProgress(wrap), { passive: true });
    window.addEventListener('resize', () => updateProgress(wrap));
    updateProgress(wrap);
    });
  });
})();
